export const VLAN_REGEX = /^\d{1,4}$/;
export const VLAN_REGEX_STRING = VLAN_REGEX.source;
